import React from 'react';
import './App.css';
import Nav from './components/nav/Nav';

function App() {
  return (
    <div className="App">
      <Nav />
    </div>
  );
}

export default App;
